import { ItemCategoryService, ItemsService, ItemSubCategoryService, RmRackPositionService, SizesService, UnitcodeService } from '@gtpl/shared-services/masters';
import { IndentformService, StockService } from '@gtpl/shared-services/procurement';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { StockRepository } from '../grn/repository/stock-repository';
import { TransferMaterialAdapter } from './adapter/transfer-material-adapter';
import { LocationWiseTranfers } from './entities/location-wise-transfers.entity';
import { LocationWiseStockLogRepository } from './repositories/location-wise-stock-log.repository';
import { TransferItemsRepository } from './repositories/transfer-items.repository';
import { TransferRepository } from './repositories/transfer-materail.repository';
import { TransferMaterialController } from './transfer-material.controller';
import { TransferMaterialService } from './transfer-material.service';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';

@Module({
  imports: [
    TypeOrmModule.forFeature([TransferRepository, TransferItemsRepository, LocationWiseTranfers, StockRepository]),
  ],
  controllers: [TransferMaterialController],
  providers: [TransferMaterialService, TransferMaterialAdapter, ApplicationExceptionHandler, UnitcodeService, ItemCategoryService, ItemsService, SizesService, ItemSubCategoryService, RmRackPositionService,IndentformService,SaleOrderService,LogsService,StockService,LocationWiseStockLogRepository]
})
export class TransferMaterialModule { }
